"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretDirection = exports.CaretSize = void 0;
var CaretSize;
(function (CaretSize) {
    CaretSize["Small"] = "small";
    CaretSize["Medium"] = "medium";
})(CaretSize = exports.CaretSize || (exports.CaretSize = {}));
var CaretDirection;
(function (CaretDirection) {
    CaretDirection["Left"] = "90deg";
    CaretDirection["Right"] = "-90deg";
    CaretDirection["Up"] = "180deg";
    CaretDirection["Down"] = "0";
})(CaretDirection = exports.CaretDirection || (exports.CaretDirection = {}));
